import { Fragment, useRef, useState, useContext } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { FechasRadioGroup } from "../radioGroups/fechasRadioGroup";
import { OfertaViewContext } from "../../context/OfertaContext/OfertaViewContext";


export function OfferDialog({ dialogOpen, setDialogOpen, creditUser, updateCreditUser }) {
  const { ofertaViewData } = useContext(OfertaViewContext);
  const [open, setOpen] = useState(dialogOpen);

  const cancelButtonRef = useRef(null);
  const handleToggleDialog = () => {
    if (dialogOpen) {
      setDialogOpen(false);
    } else {
      setDialogOpen(true);
    }
  };

  const handleApplyChanges = () => {
    if (dialogOpen) {
      setDialogOpen(false);
    } else {
      setDialogOpen(true);
    }
    updateCreditUser(ofertaViewData);
  }

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }


  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={handleToggleDialog}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-tdark bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="text-tdark font-walsheim tracking-tight relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div>
                  <div className="mt-3 text-center sm:mt-5">
                    <Dialog.Title
                      as="h3"
                      className="text-xl font-semibold"
                    >
                      Elige una fecha de pago
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm">
                        Ten en cuenta que la fecha de escojas podrá afectar el cálculo de interés corriente y Firma electrónica si deseas usarla
                      </p>
                    </div>

                    <div className="mt-2">
                      <FechasRadioGroup
                        creditUser={creditUser}
                        updateCreditUser={updateCreditUser}
                        amount={Number(creditUser?.approvedQuota)} />
                    </div>

                  </div>
                </div>
                <div className="block">
                  <div className="mt-5 sm:mt-6 flex gap-2">
                    <div className="w-full">
                      <button
                        className="w-full text-md flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm font-semibold text-tdark bg-purpleLight transition duration-300 hover:bg-purple  hover:text-white focus:outline-none"
                        onClick={handleToggleDialog}>Cancelar</button>
                    </div>

                    <div className="w-full">
                      <button
                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-md font-semibold text-white bg-purple transition duration-300 hover:bg-purpleDark focus:outline-none"
                        onClick={handleApplyChanges}>Aplicar</button>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}